import { createContext, useContext, type RefObject } from "react";

// The dock card, so popovers opened from its controls centre on the card, not their trigger.
export const DockCardContext = createContext<RefObject<HTMLElement | null> | null>(null);
export const useDockCard = () => useContext(DockCardContext);

// Card edge to popover edge, shared by every popover opened from the dock.
export const dockPopoverProps = { side: "top", align: "center", sideOffset: 12 } as const;
